import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
    loadEventWhatsappChat,
} from "../../../../redux/admin/EventActions";
import { getEventWhatsappChat } from "../../../../redux/admin/EventReducer";

// Sales-frontend Whatsapp Logs sub-tab body. Reads the chat-message rows for
// the open lead's event_id from the redux slice populated by
// loadEventWhatsappChat (proxied event-api → vm-message-service).
// Renders bubbles: bot/system on the left, user inbound on the right.
export default function WhatsappChat({ eventId }) {
    const dispatch = useDispatch();
    const { loading, messages, error } = useSelector(getEventWhatsappChat);

    useEffect(() => {
        if (eventId) {
            dispatch(loadEventWhatsappChat(eventId));
        }
    }, [eventId, dispatch]);

    if (!eventId) {
        return (
            <div style={emptyStyle}>Open a saved lead to see its WhatsApp chat.</div>
        );
    }
    if (loading) {
        return <div style={emptyStyle}>Loading…</div>;
    }
    if (error) {
        return (
            <div style={{ ...emptyStyle, color: "#c0392b" }}>
                Failed to load chat. {error}
            </div>
        );
    }
    if (!messages || messages.length === 0) {
        return (
            <div style={emptyStyle}>
                No WhatsApp messages tied to this event yet.
            </div>
        );
    }

    return (
        <div style={listStyle}>
            {messages.map((m) => {
                const isBot = !!m.is_bot_message;
                return (
                    <div
                        key={m._id}
                        style={{
                            ...rowStyle,
                            justifyContent: isBot ? "flex-start" : "flex-end",
                        }}
                    >
                        <div
                            style={{
                                ...bubbleStyle,
                                backgroundColor: isBot ? "#f1f0f0" : "#dcf8c6",
                                marginLeft: isBot ? 0 : "auto",
                                marginRight: isBot ? "auto" : 0,
                            }}
                        >
                            <div style={textStyle}>{m.text || m.raw_text || "—"}</div>
                            <div style={metaStyle}>
                                {m.bot_flow_key ? (
                                    <span style={tagStyle}>{m.bot_flow_key}</span>
                                ) : null}
                                {m.message_code ? (
                                    <span style={tagStyle}>{m.message_code}</span>
                                ) : null}
                                <span style={timeStyle}>
                                    {m.created_at
                                        ? moment(m.created_at).format("DD MMM, HH:mm")
                                        : ""}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

const emptyStyle = {
    padding: 24,
    textAlign: "center",
    color: "#666",
    fontSize: 13,
};

const listStyle = {
    maxHeight: 480,
    overflowY: "auto",
    padding: 12,
    backgroundColor: "#fafafa",
    border: "1px solid #eee",
    borderRadius: 4,
};

const rowStyle = {
    display: "flex",
    marginBottom: 8,
};

const bubbleStyle = {
    maxWidth: "75%",
    padding: "8px 12px",
    borderRadius: 8,
    boxShadow: "0 1px 1px rgba(0,0,0,0.06)",
};

const textStyle = {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontSize: 13,
    color: "#222",
};

const metaStyle = {
    marginTop: 4,
    fontSize: 11,
    color: "#7a7a7a",
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexWrap: "wrap",
};

const tagStyle = {
    padding: "1px 6px",
    backgroundColor: "#e7e7e7",
    borderRadius: 8,
    fontSize: 10,
    color: "#555",
};

const timeStyle = {
    marginLeft: "auto",
};
